/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Apikeymanager_Notification_Cleared2Inputs */

const id_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci API berhasil dihapus!`)
};

const ms_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci API berjaya dikosongkan!`)
};

const da_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API nøgle ryddet succesfuldt!`)
};

const de_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Schlüssel erfolgreich gelöscht!`)
};

const en_us2_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key cleared successfully!`)
};

const es_es2_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Clave de API borrada correctamente!`)
};

const es_mx2_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡API key borrada exitosamente!`)
};

const fil_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matagumpay na na-clear ang API key!`)
};

const fr_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clé API effacée avec succès !`)
};

const it_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiave API cancellata con successo!`)
};

const hu_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API kulcs sikeresen törölve!`)
};

const nl_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-sleutel succesvol gewist!`)
};

const no_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-nøkkel fjernet!`)
};

const pl_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klucz API wyczyszczony pomyślnie!`)
};

const pt_br2_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key cleared successfully!`)
};

const pt_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chave de API limpa com sucesso!`)
};

const ro_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheia API a fost ștearsă cu succes!`)
};

const fi_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-avain tyhjennetty onnistuneesti!`)
};

const sv_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-nyckel rensad!`)
};

const vi_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xóa khóa API thành công!`)
};

const tr_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API anahtarı başarıyla temizlendi!`)
};

const cs_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API klíč úspěšně vymazán!`)
};

const bg_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API ключът е изчистен успешно!`)
};

const ru_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-ключ успешно очищен!`)
};

const uk_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-ключ успішно очищено!`)
};

const ar_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم مسح مفتاح API بنجاح!`)
};

const hi_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`साफ़ की गई!`)
};

const th_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ล้างคีย์ API สำเร็จ!`)
};

const ja_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API キーをクリアしました！`)
};

const zh_cn2_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key cleared successfully!`)
};

const zh_hant1_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key cleared successfully!`)
};

const ko_components_apikeymanager_notification_cleared2 = /** @type {(inputs: Components_Apikeymanager_Notification_Cleared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key cleared successfully!`)
};

/**
* | output |
* | --- |
* | "API key cleared successfully!" |
*
* @param {Components_Apikeymanager_Notification_Cleared2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_apikeymanager_notification_cleared2 = /** @type {((inputs?: Components_Apikeymanager_Notification_Cleared2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Apikeymanager_Notification_Cleared2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "ms") return ms_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "da") return da_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "de") return de_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "en-US") return en_us2_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "es-ES") return es_es2_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "es-MX") return es_mx2_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "fil") return fil_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "fr") return fr_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "it") return it_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "hu") return hu_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "nl") return nl_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "no") return no_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "pl") return pl_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "pt-BR") return pt_br2_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "pt") return pt_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "ro") return ro_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "fi") return fi_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "sv") return sv_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "vi") return vi_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "tr") return tr_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "cs") return cs_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "bg") return bg_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "ru") return ru_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "uk") return uk_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "ar") return ar_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "hi") return hi_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "th") return th_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "ja") return ja_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_apikeymanager_notification_cleared2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_apikeymanager_notification_cleared2(inputs)
	return ko_components_apikeymanager_notification_cleared2(inputs)
});
export { components_apikeymanager_notification_cleared2 as "components.apiKeyManager.notification.cleared" }